export default "__VITE_ASSET__ea80f5d6__"